module.exports = __webpack_public_path__ + "static/img/26835.6ddb9e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/dxzg/26835.png
// module id = CG9g
// module chunks = 0